import styled, { keyframes } from 'styled-components';
import * as palette from '../../styles/variables';
import { Button, Icon } from 'antd';

const fadeText = keyframes` 
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
`;
const fadeOut = keyframes` 
  from {
    width: 0;
    transform: translate3d(0, 100%, 0);
  }
  to {
    width: 10%;
    transform: none;
  }
`;
const fadeTitle = keyframes` 
  from {
    overflow: hidden;
    transform:translate(0, 100px)

  }
  to { 
    overflow: visible;
  }
`;
const fadeTempTitle = keyframes` 
  from {
    overflow: hidden;
    transform:translate(0, 180px)

  }
  to {
    overflow: visible;
  }
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: ${props => props.isUploadFile && '100%'};
  background: ${palette.WHITE_COLOR} .box1 {
    background: #000;
    border-radius: 6px;
    height: 1px;
    width: 0px;
    transform: translate(0px, 0px);
    &.inViewLine {
      margin-top: 40px;
      visibility: visible !important;
      animation: ${fadeOut} 1s ease-in-out 0s forwards;
    }
    @media only screen and (min-width: 2560px) {
      height: 2px;
      width: 200px;
    }
  }
  .categoryName {
    font-size: ${props => (props.uploadExcel ? '10px !important' : '11.4px !important')};
    font-weight: 600;
    font-family: ${palette.FONT_FAMILY_LANDPAGE};
    color: #888888 !important;
    display: flex;
    align-items: center;
    line-spacing: 1.2px;
    @media only screen and (min-width: 2560px) {
      font-size: 21.4px !important;
      font-weight: 600;
    }
    .categ_Name {
      width: 240px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;      
    }
  }
  .box2 {
    margin-right: 10px;
    border-radius: 6px;
    height: 1px;
    width: 50px;
    transform: translate(0px, 0px);
    background: #888888;
    @media only screen and (min-width: 2560px) {
      width: 70px;
      margin-top: 30px;
    }
  }
  .fade-enter .test {
    transform: scale(0);
  }
  .fade-enter-active .test {
    transform: scale(1);
  }
  .fade-exit .test {
    transform: scale(1);
  }
  .fade-exit-active .test {
    transform: scale(0);
  }
  .fade-enter-active .test,
  .fade-exit-active .test {
    transition: opacity 200ms, transform 200ms;
  }
  .input-container {
    transition: all 0.08s ease-in;
    overflow: hidden;
  }
  h3 {
    font-size: 20px;
    text-transform: capitalize;
    font-weight: 600;
    text-align: center;
    font-family: ${palette.FONT_FAMILY_TEMPLATE};
    cursor: pointer;
  }
`;

export const TemplateTitleSec = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: ${props => (props.isPublishedTemp ? '60px' : '125px')};
  justify-content: center;
  overflow: hidden;
  margin: 20px;
  margin-bottom: 0 !important;
  .template_title {
    font-size: ${props => (props.isPublishedTemp ? '30px' : '50px')};
    font-weight: 400;
    color: #000;
    font-family: ${palette.FONT_FAMILY_TEMPLATE};
    @media only screen and (min-width: 2560px) {
      animation-delay: 0.5s;
      font-size: ${props => (props.isPublishedTemp ? '40px' : '95px')};
      margin-top: 70px;
    }
    @media only screen and (min-width: 1460px) {
      animation-delay: 0.5s;
      font-size: ${props => (props.isPublishedTemp ? '30px' : '55px')};
    }
    @media only screen and (max-width: 728px) {
      font-size: ${props => (props.isPublishedTemp ? '25px' : '35px')};
    }
    animation: ${fadeTitle} 1s ease-in-out 0s backwards;
    @media only screen and (min-width: 1460px) {
      animation: ${fadeTempTitle} 1s ease-in-out 0s backwards !important;
    }
  }
  .template_desc {
    font-size: 10px;
    text-transform: uppercase;
    font-weight: 400;
    color: #000;
    font-family: 'Roboto', sans-serif;
    animation: ${fadeTitle} 1s ease-in-out 0s backwards;
    @media only screen and (min-width: 1460px) {
      animation: ${fadeTempTitle} 1s ease-in-out 0s backwards !important;
    }
    @media only screen and (min-width: 2560px) {
      animation-delay: 0.5s;
      font-size: 20px;
      margin-top: 70px;
    }
    @media only screen and (min-width: 1460px) {
      animation-delay: 0.5s;
      font-size: 13px;
    }
  }
`;

export const SearchTitle = styled.div`
  font-size: 30px !important;
  color: #fff !important;
  text-transform: capitalize;
  font-weight: 400;
  margin: 0 !important;
  font-family: ${palette.FONT_FAMILY_TEMPLATE};
  @media only screen and (min-width: 2560px) {
    font-size: 50px !important;
  }
  @media only screen and (min-width: 1460px) {
    font-size: 40px !important;
  }
`;

export const TemplateConatiner = styled.div`
  width: 100%;
  height: ${props => props.isUploadFile && '100%'};
  .ant-tabs-nav .ant-tabs-tab {
    text-transform: uppercase;
    font-size: 11.4px;
    letter-spacing: 1px;
    font-weight: 700;
    color: #888888;
    margin: 5px;
    padding: 15px;
    line-height: 14.8px;
    @media only screen and (min-width: 2560px) {
      font-size: 22.4px !important;
      margin: 10px;
      letter-spacing: 1.5px;
      font-weight: 500;
    }
    @media only screen and (max-width: 1024px) {
      padding: 10px;
    }
    @media only screen and (max-width: 768px) {
      font-size: 8.4px !important;
      font-weight: 500;
      padding: 4px;
    }
  }
  .ant-tabs-nav .ant-tabs-tab-active {
    color: #000;
    font-weight: 700;
  }
  .ant-tabs-nav .ant-tabs-tab:hover {
    color: #000;
  }
  .ant-tabs-ink-bar {
    height: 1px;
    background-color: #000;
  }
  .ant-tabs-tab-prev-icon,
  .ant-tabs-tab-next-icon {
    top: 28%;
  }
  @media only screen and (min-width: 2560px) {
    .ant-tabs-tab-prev-icon,
    .ant-tabs-tab-next-icon {
      top: 20%;
    }
    .ant-tabs-tab-prev-icon-target,
    .ant-tabs-tab-next-icon-target {
      font-size: 30px !important;
    }
  }
  .ant-tabs-bar {
    border: none !important;
  }
  .ant-tabs {
    margin: 13%;
    margin-top: 0;
    margin-bottom: 0;
  }
  .ant-tabs-nav {
    width: 100%;
    text-align: center;
  }
  .ant-tabs-bar {
    border: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-tabs-nav-scroll {
    overflow: hidden;
    width: 100%;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
    @media only screen and (max-width: 768px) {
      width: 80vw;
    }
    @media only screen and (max-width: 425px) {
      width: 130vw;
    }
    @media only screen and (max-width: 375px) {
      width: 150vw;
    }
    @media only screen and (max-width: 320px) {
      width: 175vw;
    }
    @media only screen and (min-width: 2560px) {
      margin-bottom: 100px;
    }
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
  .addMore {
    height: 40px;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    color: rgb(219, 57, 31);
    margin-left: ${props => props.isUploadFile && '25%'};
    .anticon {
      margin-right: 20px;
      color: rgb(219, 57, 31);
    }
  }
  .allData {
    text-align: center;
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 25px !important;
    margin-left: ${props => props.isUploadFile && '25%'};
  }
`;

export const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 10%;
`;

export const EmptySettingsDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
  .empty-illustration {
    max-width: 120px;
  }
  .empty-txt {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    max-width: 245px;
    font-size: 14px;
    color: #000;
    margin-top: 20px;
    span {
      margin-right: 5px;
      text-align: center;
    }
    .empty-links {
      text-decoration: underline;
      color: #2c8fc7;
      font-weight: bold;
      &:hover {
        cursor: pointer;
      }
    }
  }
`;

export const TemplateWrapper = styled.div`
  align-items: start;
  display: grid;
  margin-top: ${props => (props.isUploadFile ? '5%' : '10px')};
  column-gap: 50px;
  grid-template-columns: repeat(auto-fit, 250px);
  justify-content: center;
  @media only screen and (min-width: 1440px) {
    column-gap: ${props => (props.isUploadFile ? '50px' : '75px')};
    grid-template-columns: repeat(auto-fit, 300px);
  }
  @media only screen and (min-width: 2560px) {
    grid-template-columns: repeat(auto-fit, 450px);
    column-gap: ${props => (props.isUploadFile ? '75px' : '100px')};
  }
`;

export const TemplatePageOverview = styled.div`
  padding: 0px 0 60px;
  cursor: pointer;
  padding: ${props => props.uploadExcel && '15px'};
  background: ${props => props.uploadExcel && '#fff'};
  box-shadow: ${props => props.uploadExcel && 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; !important'};
  margin-bottom: ${props => props.uploadExcel && '50px'};
  &:hover {
    .ant-dropdown-trigger.anticon-more {
      color: #000 !important;
      padding: 7px;
      border-radius: 4px;
      &:hover {
        background-color: #000;
        color: #fff !important;
      }
    }
  }
  &.inView {
    animation: ${fadeText} 1s ease-in-out 0s forwards;
  }
  position: relative;
  .template_name {
    color: #000 !important;
    font-family: ${palette.FONT_FAMILY_Cinzel};
    text-transform: uppercase;
    font-size: ${props => (props.uploadExcel ? '16px' : '18px')};
    font-weight: 700;
    line-height: 38.6px;
    @media only screen and (min-width: 1460px) {
      font-size: 14px;
    }
    @media only screen and (min-width: 2560px) {
      font-size: 35px;
      line-height: 61.6px;
      margin: 40px;
      margin-left: 0;
    }
    .name {
      cursor: pointer;
      width: 240px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .template_date {
      position: absolute;
      top: 270px;
      right: 10px;
      width: 70px;
      height: 70px;
      background: rgb(243 242 245);
      border-radius: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      p {
        font-size: 23.8px !important;
      }
      .month {
        color: #888888;
        font-size: 11.4px !important;
        letter-spacing: 1px;
        font-family: ${palette.FONT_FAMILY_LANDPAGE};
      }
      @media only screen and (min-width: 1440px) {
        top: 320px;
      }
      @media only screen and (min-width: 2560px) {
        width: 140px;
        height: 140px;
        top: 450px;
        p {
          font-size: 40.8px !important;
        }
        .month {
          font-size: 23.4px !important;
        }
      }
    }
  }
`;
export const TemplateImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => (props.uploadExcel ? 'rgb(244, 244, 246)' : '#fff')};
  width: 100%;
  box-sizing: border-box;
  box-shadow: ${props => (props.uploadExcel ? '' : '0 1rem 3rem rgba(0, 0, 0, 0.175) !important')};
  margin-bottom: 15px;
  height: ${props => (props.uploadExcel ? '100px' : props.refElement ? '300px' : '350px')};
  overflow: hidden;
  &.template_media {
    border: 2px solid red;
  }
  @media only screen and (min-width: 1440px) {
    height: ${props =>
      props.uploadExcel ? '100px' : props.refElement ? '350px' : '400px'}!important;
  }
  @media only screen and (min-width: 2560px) {
    height: ${props =>
      props.uploadExcel ? '100px' : props.refElement ? '650px' : '600px'}!important;
  }
  img {
    object-fit: ${props => (props.mailTemplate ? 'contain' : 'initial')};
    max-height: ${props => (props.refElement ? '300px' : '350px')}!important;
    max-width: 100%;
    cursor: pointer;
    &:hover {
      transform: scale(1.02);
    }
    @media only screen and (min-width: 1440px) {
      max-height: ${props =>
        props.uploadExcel ? '100px' : props.refElement ? '350px' : '400px'}!important;
    }
    @media only screen and (min-width: 2560px) {
      max-height: ${props =>
        props.uploadExcel ? '100px' : props.refElement ? '650px' : '750px'}!important;
    }
  }
  &.show-loader {
    background-image: url('./generatingPreview.png');
    background-repeat: no-repeat;
    background-position: center;
  }
  .no-thumbnail {
    width: auto;
    max-width: fit-content;
  }
  .secondary {
    position: absolute;
    display: flex;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    opacity: 0;
    background: rgb(37, 41, 45);
    transition: 0.6s ease-out;
    height: ${props => (props.refElement ? '300px' : '350px')};
    @media only screen and (min-width: 1440px) {
      height: ${props => (props.refElement ? '350px' : '400px')}!important;
    }
    @media only screen and (min-width: 2560px) {
      height: ${props => (props.refElement ? '650px' : '750px')}!important;
    }
    p {
      color: #fff;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      text-transform: uppercase;
      width: 100%;
    }
  }
  &:hover {
    .secondary {
      opacity: 0.8;
    }
  }
`;

export const TemplateShortMessageImage = styled.div`
  position: relative;
  /* display: flex; */
  word-wrap: break-word;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
  /* background: #fff; */
  /* background-image: url(${props => props.activeContent === "whatsapp" ? "https://i.pinimg.com/736x/8c/98/99/8c98994518b575bfd8c949e91d20548b.jpg" : props.activeContent === "sms" ? "https://shorturl.at/dmsR4" : "https://shorturl.at/nwJK3"}); */
  background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0)), url(${props => props.activeContent === "whatsapp" ? "https://i.pinimg.com/736x/8c/98/99/8c98994518b575bfd8c949e91d20548b.jpg" : props.activeContent === "sms" ? "https://shorturl.at/bqvL2" : "https://shorturl.at/nGJ68"});
  background-size: cover;
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
  margin-bottom: 15px;
  /* height: ${props => (props.refElement ? '300px' : '350px')}; */
  height: 250px;
  /* overflow: hidden; */
  padding: 20px;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: start;
  font-family: ${palette.FONT_FAMILY_LANDPAGE};
  .preview-whatsapp-msg {
    background: #dcf8c6;
    padding: 8px 20px;
    box-shadow: 0 3px 3px 0 #b7b7b7;
    border-radius: 15px 15px 15px 0;
    position: relative;
    margin-left: 20px;
    height: 176px;
    width: 390px;
    &::before {
      content: ' ';
      position: absolute;
      bottom: 0px;
      left: -18px;
      width: 0;
      height: 0;
      border-top: 15px solid transparent;
      border-right: 20px solid #dcf8c6;
      border-bottom: 0px solid transparent;
      box-shadow: 0 3px 0px 0 #c7c4c4;
    }
  }
  .preview-msg {
    height: ${props => (props.refElement ? '200px' : '200px')}!important;
    width: ${props => (props.refElement ? '250px' : '250px')}!important;
    font-size: 18px !important;
    font-weight: bold;
    /* background: #e9e9e9; */
    padding: 8px 20px;
    /* box-shadow: 0 3px 3px 0 #b7b7b7; */
    /* border-radius: 15px 15px 15px 0; */
    position: relative;
    margin-left: 20px;
    height: 176px;
    width: 390px;
    /* &::before {
      content: " ";
      position: absolute;
      bottom: 0px;
      left: -18px;
      width: 0;
      height: 0;
      border-top: 15px solid transparent;
      border-right: 20px solid #e9e9e9;
      border-bottom: 0px solid transparent;
      box-shadow: 0 3px 0px 0 #c7c4c4;
    } */
  }
  .template_date {
    position: absolute;
    right: 0;
    bottom: 0;
    margin: 12px;
    width: 70px;
    height: 70px;
    background: rgb(243 242 245);
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p {
      font-size: 23.8px !important;
      font-family: Cinzel, serif;
      font-weight: 700;
    }
    .month {
      color: #888888;
      font-size: 11.4px !important;
      letter-spacing: 1px;
      font-family: ${palette.FONT_FAMILY_LANDPAGE};
      text-transform: uppercase;
    }
    @media only screen and (min-width: 2560px) {
      width: 140px;
      height: 140px;
      margin-left: auto;
      p {
        font-size: 40.8px !important;
      }
      .month {
        font-size: 23.4px !important;
      }
    }
  }
  &.template_media {
    border: 2px solid red;
  }

  @media only screen and (max-width: 1440px) {
    height: 250px !important;
    width: 250px !important;
    font-size: 18px !important;
    font-weight: bold;
    position: relative;
  }
  @media only screen and (min-width: 1440px) {
    height: 350px !important;
    width: 350px !important;
    font-size: 24px !important;
    font-weight: bold;
    position: relative;
  }
  .secondary {
    position: absolute;
    display: flex;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    opacity: 0;
    background: rgb(37, 41, 45);
    transition: 0.6s ease-out;
    height: ${props => (props.refElement ? '300px' : '350px')};
    width: ${props => (props.refElement ? '400px' : '350px')};
    @media only screen and (min-width: 1440px) {
      height: ${props => (props.refElement ? '350px' : '300px')}!important;
      width: ${props => (props.refElement ? '350px' : '400px')}!important;
    }
    @media only screen and (min-width: 2560px) {
      height: ${props => (props.refElement ? '650px' : '750px')}!important;
    }
    p {
      color: #fff;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      text-transform: uppercase;
      width: 100%;
    }
  }
  &:hover {
    .secondary {
      opacity: 0.8;
    }
  }
`;

export const DropdownDetails = styled.div`
  align-items: center;
  position: absolute;
  right: 10px;
  top: 10px;
  color: transparent;
  &.dropdown-visible {
    display: flex;
  }
  .anticon-more {
    transform: rotate(90deg);
  }
  .ant-dropdown {
    top: 20px !important;
    right: 2px !important;
    left: initial !important;
    .ant-dropdown-menu {
      min-width: 100px;
    }
    .ant-dropdown-menu-item {
      font-weight: bold;
      font-size: 14px;
      padding: 6px 12px;
      margin: 1px 0px;
    }
  }
`;
export const SearchBar = styled.div`
  display:flex;
  justify-content: center;
  align-items: center;
  // border: 2px solid #2f3640; 
  // border-radius: 30px;
  // background:#2f3640;
  height: 45px;
  width: 65px;
  // margin: 26px;
  // margin-top: 0px;
  // margin-bottom:5px;
  @media only screen and (min-width: 2560px) {
    // margin:70px; 
    height: 115px;
    width: 115px;
    border: 2px solid #2f3640;
    border-radius: 138px;
    
  }
  @media only screen and (max-width: 768px) {
    height: 55px;
      width: 55px;
  }
  .ant-input {
    border: 1px solid transparent !important;
    font-family:Raleway,sans-serif !important
    width:55%;
    // background: #2f3640;     
    z-index:-1 ;
  }
  .ant-input:focus {
    box-shadow: none !important;
}

.anticon-search ,.anticon-close-circle{
  transition: .5s ease-in-out ;
  display:flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  font-size: 20px;
  color: #fff;
  margin-right: 25px;

  @media only screen and (min-width: 2560px) {
    padding: 15px;
    font-size: 35px;
    color: #fff;
    margin-right: 25px;
  }
  @media only screen and (max-width: 768px) {
    padding: 3px;   
  }
}
 &.focused,&:hover{
    transition: 0.5s ease-in-out
    width: 100%;
    .ant-input {
      font-family:Raleway,sans-serif !important
      transition: 0.55s ease-in-out;
      display:inline-block !important;
      border: 1px solid transparent !important;
      font-size: 13px;
      padding: 10px;
      height: 80%;
      border-radius: 8px;
      color:#000; 
      width:100% !important;    
      z-index:1; 
    }
    .ant-input:placeholder-shown{
      font-family:Raleway,sans-serif !important;
      ::placeholder {
        color: #767676 !important;
      }
    }
    .ant-input-affix-wrapper{
      width:100% !important;  
    }
    .anticon-search,.anticon-close-circle {
      transition: .5s ease-in-out
      margin: 0;
      background:transparent;
      color: #cacaca;
    }
    .anticon-close-circle {
      position: absolute;
      left: -20px;
    }  
  }
 
`;

export const ActiveContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: ${props => (props.isPublishedTemp && '12%')};
  column-gap: ${props => props.isMaster ? '60px' : '20px'};
  margin: 25px;
  margin-top: ${props => props.isPublishedTemp && '0'};
  @media only screen and (min-width: 1460px) {
    margin: 40px;
    margin-top: ${props => props.isPublishedTemp && '0'};
  }
  @media only screen and (max-width: 456px) {
    flex-direction: column;
  }
`;

export const ContentType = styled.div`
  position: relative;
  padding: 25px;
  padding-right: 0;
  padding-left: 0;
  padding-top: ${props => props.isPublishedTemp && '0'}!important;
  .text {
    color: #fff;
    text-transform: uppercase;
    font-size: 12px;
    margin-left: 10px @media only screen and (min-width: 1440px) {
      font-size: 15px;
    }
  }
  .toggleWrapper {
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    width: 210px;   
    height: 50px;
    @media only screen and (min-width: 1440px) {
      width: 210px;
      height: 60px;
    }
    border-radius: 50px;
    background: linear-gradient(to right, #ef9d43, #e75516);
    box-shadow: 0 20px 20px 0 rgba(254, 69, 81, 0.3);
  }
  .toggleWrapper:active {
    width: 150px;
    height: 50px;
    @media only screen and (min-width: 1440px) {
      width: 180px;
      height: 60px;
    }
    box-shadow: 0 20px 20px 0 rgba(254, 69, 81, 0.3);
  }
  .toggleWrapper:active .toggle {
    width: 150px;
    height: 50px;
    @media only screen and (min-width: 1440px) {
      width: 180px;
      height: 60px;
    }
  }
  .toggleWrapper .toggle {
    transition: all 0.2s ease-in-out;
    width: 150px;
    height: 50px;
    margin-right: 10px;
    @media only screen and (min-width: 1440px) {
      width: 180px;
      height: 60px;
    }
    background-color: transparent;
    border: 10px solid #fff;
    border-radius: 50%;
    cursor: pointer;
    animation: red 0.7s linear forwards;
  }

  .switch + .toggleWrapper {
    background: linear-gradient(to right, #6b8dd6, #8e37d7) !important;
    box-shadow: rgb(46 9 58 / 40%) 0px 20px 20px 0px;
  }
  .switch + .toggleWrapper:active {
    box-shadow: rgb(46 9 58 / 40%) 0px 20px 20px 0px;
  }
  .switch + .toggleWrapper .toggle {
    width: 0;
    background-color: #fff;
    border-color: transparent;
    border-radius: 30px;
    animation: green 0.7s linear forwards !important;
  }

  @keyframes red {
    0% {
      height: 40px;
      width: 0;
      border-width: 5px;
    }
    55% {
      height: 23px;
      width: 37px;
      border-width: 10px;
    }
    70% {
      height: 30px;
      width: 30px;
      border-width: 10px;
    }
    85% {
      height: 25px;
      width: 35px;
      border-width: 10px;
    }
    100% {
      height: 30px;
      width: 30px;
      border-width: 10px;
    }
  }
  @keyframes green {
    0% {
      height: 20px;
      width: 30px;
      border-width: 10px;
    }
    25%,
    55%,
    85% {
      height: 30px;
      width: 15px;
      border-width: 5px;
    }
    40%,
    70%,
    100% {
      height: 30px;
      width: 0;
      border-width: 5px;
    }
  }
  .anticon {
    font-size: 20px;
    color: transparent;
    position: relative;
    border-radius: 50%;
    padding: 5px;
    margin: 3px;
    box-shadow: none;
    transition: color 0.2s ease, background-color 0.2s ease, transform 0.3s ease;
    @media only screen and (min-width: 1460px) {
      font-size: 22px;
      padding: 8px;
    }
  }
  .anticon:nth-of-type(1) {
    background-color: transparent;
    position: absolute;
    left: 40%;
  }
  &:hover {
    .anticon:nth-of-type(1) {
      color: #fff;
      background: rgb(37, 41, 45);
      z-index: 20;
    }

    .anticon {
      background-color: transparent;
      transform: translateY(-50px) rotate(360deg);
      cursor: pointer;
      box-shadow: none;
    }
  }
`;
export const AdvSearchIcon = styled(Icon)`
  position: ${props => (props.showSearchIcon ? 'fixed' : 'absolute')};
  top: ${props => (props.showSearchIcon ? '0' : '190px')};
  right: ${props => (props.showSearchIcon ? '24vw' : '0')};
  z-index: 10;
  background: rgb(37, 41, 45);
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  padding: 20px;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  color: #fff;
  @media only screen and (min-width: 1460px) {
    top: ${props => (props.showSearchIcon ? '0' : '225px')};
  }
`;

export const FilterTitle = styled.div`
  color: #fff;
  font-size: 11px;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  // line-height: 40px;
  margin: 15px;
  letter-spacing: 1px;
  text-align: left;
  width: 100%;
  @media only screen and (min-width: 1460px) {
    font-size: 14px;
    margin: 20px;
  }
  &.clearFilter {
    cursor: pointer;
    font-size: 12px !important;
    width: 100%;
    text-align: center;
    font-weight: 100;
    text-transform: unset;
    line-height: 2;
    margin: 5px;
    &:hover {
      text-decoration: underline;
    }
    @media only screen and (min-width: 1460px) {
      font-size: 15px !important;
    }
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: flex-start;
  padding-left: 25px;
  padding-right: 25px;
  @media screen and (max-height: 640px) {
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .ant-checkbox-group {
    width: 100%;
    max-height: 190px;
    @media only screen and (min-width: 1460px) {
      max-height: 290px;
    }
  }
  .ant-checkbox-group-item {
    width: 100%;
    @media only screen and (min-width: 1460px) {
      padding: 5px;
      padding-left: 0 !important;
    }
  }
  .ant-checkbox + span {
    padding-right: 8px;
    padding-left: 8px;
    font-family: Raleway, sans-serif;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 2px;
    fill: #585858;
    color: #d8d6d6;
    background-color: rgba(0, 0, 0, 0);
    border-radius: 0px 0px 0px 0px;
    @media only screen and (min-width: 1460px) {
      font-size: 12px;
    }
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background: linear-gradient(to right, #ef9d43, #e75516);
    border-color: rgb(219, 57, 31);
    border: 2px solid rgb(219, 57, 31) !important;
  }
  .ant-checkbox-checked::after {
    border-color: rgb(219, 57, 31);
    border: 1px solid rgb(219, 57, 31);
  }
  .ant-divider-horizontal {
    margin: 10px 0px;
  }
  .ant-checkbox-wrapper {
    text-align: left;
    width: 100%;
  }
  .button {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .anticon.anticon-loading {
    color: #fff;
    font-size: 30px;
    padding: 20px;
  }
`;
export const SearchButton = styled(Button)`
  font-size: 11.4px;
  font-weight: 700 !important;
  letter-spacing: 1px;
  font-family: ${palette.FONT_FAMILY_LANDPAGE} !important;
  line-height: 1.3;
  height: 35px;
  width: 130px;
  text-transform: uppercase;
  border-radius: 64px;
  background: linear-gradient(to right, #ef9d43, #e75516);
  border: transparent;
  animation: ${fadeText} 1s ease-in-out 0s forwards;
  color: #fff;
  z-index: 1;
  @media only screen and (min-width: 1460px) {
    font-size: 14px;
    letter-spacing: 1.5px;
    height: 40px;
    width: 180px;
  }
  &:hover,
  &:focus {
    background: linear-gradient(to right, #ef9d43, #e75516);
    border: transparent;
    color: #fff;
  }
`;
export const ErrorMessage = styled.div`
  ${props => props.complexEmailTransactions &&
  `
    position: fixed;
    top: 0;
    right: 0;
  `}
  width: ${props => props.complexEmailTransactions ? '70%' : '100%'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 0.5px;
    font-weight: 700;
    padding: 5px;
    border-radius: 5px;
  }
  .errorSection{
    display: flex;
    width: ${props => (props.width === '90%' ? '80%' : '100%')};
    align-items:center;
    justify-content:center;
    position: absolute;
    top: 0;
    .ant-alert-error {
      background-color: rgb(199, 81, 81);
      border: 1px solid rgb(199, 81, 81);
      margin: 12px;
      color: rgb(255, 255, 255);
      /* height: 30px; */
      max-width: 80%;
    }
    .errMsg {
      overflow: hidden;
      text-overflow: ellipsis;
      letter-spacing: 2px;
      white-space: nowrap;
      text-transform: initial !important;
      font-size: 12px;
      width: ${props => props.width};
    }
    .ant-alert-message {
      color: #fff;
      letter-spacing: 2px;
      /* font-size: 13px; */
      font-weight: 700;
    }
    .ant-alert.ant-alert-closable {
      padding-right: 40px;
    }  
    .ant-alert.ant-alert-no-icon {
      padding: 5px 15px;
      z-index: 1;
    }
    .ant-alert-error {
      display: flex;
    }
    .ant-alert-close-icon {
      position: initial;
    }
    .ant-alert-close-icon .anticon-close {
      background: rgba(225, 225, 225, 0.45);
      padding: 4px;
      border-radius: 5px;
      color: #fff !important;
      font-size: 10px !important;       
    }
  }
  .error {
    background: ${props => (props.isError ? '#c75151' : 'transparent')};
    margin: ${props => (props.accessMailRoomData ? '12px' : '15px')};
    color: ${props => (props.isError ? '#fff' : 'transparent')};
    height: 30px;
    font-size: 12px;
    text-transform: initial !important;
    letter-spacing: 2px;
    max-width: 85%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .seeAllError {
    text-transform: initial !important;
    font-weight: 700 !important;
    text-decoration: underline;
    cursor: pointer;
  }
  .promptText {
    font-size: 12px;
    text-transform: initial;
    font-weight: 700;
    display: flex;
    align-items: center;
    // border-bottom: ${props => props.downloadZip && '2px solid #d5d5d5'};
    border-radius: 0px;
    padding: 40px;
    width: 100%;
    text-align: center;
    justify-content: center;
  }
  .export {
    text-transform: capitalize;
    text-decoration: underline;
    cursor: pointer !important;
    font-size: 14px;
    color: #000;
    &:hover {
      text-decoration: none !important;
    }
  }
  .generatePDF {
    margin-top: 25px;
    text-align: center;
    background: ${props => (props.downloadZip ? '#000' : props.isUploading ? '#000' : '')};
    color: #fff;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: bold;
    border-radius: 25px;
    padding: 12px;
    cursor: pointer;
    width: 175px;
  }
  p.downloadZip {
    color: #000;
    margin: 15px;
    margin-bottom: 25px;
  }
`;
export const BulkUploadButton = styled.div`
  border: 1px dotted #949494;
  border-radius: 5px;
  padding: 75px;
  margin: 50px;
  // margin-top: 0;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: ${props => (props.isUploading ? '11px' : '11px')};
  font-weight: ${props => props.isUploading && '700'};
  width: 85%;
  text-align: center;
  padding: ${props => (props.isUploading ? '115px' : '100px')};
  padding-bottom: ${props => props.isUploading && '80px !important'};
  margin-left: 75px;
  @media only screen and (min-width: 2560px) {
    padding: 300px;
    height: 700px !important;
  }
  @media only screen and (min-width: 1460px) {
    height: 450px !important;
    padding: 150px;
  }
  @media only screen and (max-width: 1360px) {
    padding: 55px !important;
  }
  .downloadZip {
    cursor: pointer;
  }
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    .anticon {
      font-size: 45px;
      color: #000000;
    }
  }
  .import {
    font-size: 14px;
    font-weight: 700;
  }
  p.desc {
    font-size: 11px;
    text-transform: initial;
    font-weight: 400;
    color: #979696;
  }
`;

export const UploadSteps = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  background: #f5f6f9;
  .ant-steps-vertical {
    position: fixed;
    top: 0;
    display: block;
    width: 25%;
    box-shadow: rgb(17 17 26 / 10%) 0px 0px 16px;
    background: #fff;
    padding-top: 10%;
    text-align: center;
    height: 100%;
  }
  .ant-steps-item-tail {
    display: none !important;
  }
  .ant-steps-vertical .ant-steps-item-icon {
    float: left;
    margin-left: 20% !important;
    margin-right: -50px !important;
  }
  .ant-steps-vertical .ant-steps-item-title {
    line-height: 32px;
    width: 60%;
    text-align: left;
    @media only screen and (min-width: 1460px) {
      width: 65%;
    }
  }
  .ant-steps-item-finish .ant-steps-item-icon {
    background-color: #3cd571;
    border-color: #3cd571;
  }
  .ant-steps-item-icon {
    width: 30px;
    height: 30px;
  }
  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: #fff;
  }
  .ant-steps-item-process .ant-steps-item-icon {
    background-color: #000;
    border-color: #000;
  }
  .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
    color: #fff;
  }
  .ant-steps-item-icon > .ant-steps-icon {
    top: -4px;
    font-size: 14px;
  }
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: #c7c7c7;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 1.5px;
    font-weight: 800;
  }
  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: rgba(0, 0, 0, 0.85);
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 1.5px;
    font-weight: 800;
  }
  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 1.5px;
    font-weight: 800;
  }
  .steps-action {
    position: absolute;
    bottom: 25px;
  }
  .next,
  .previous {
    right: 6%;
  }
  .uploadSection {
    height: 100%;
    width: 70%;
    margin-left: 28%;
    display: ${props => props.currentStep && 'flex'};
    align-items: ${props => props.currentStep && 'center'};
    .ant-btn {
      z-index: 1;
      background: #000 !important;
      color: #fff !important;
      border-radius: 0 !important;
      border: 1px solid #000 !important;
      text-transform: uppercase;
      font-size: 11px;
      letter-spacing: 1px;
    }
  }
  .desc {
    font-size: 11px !important;
    text-transform: none;
    font-weight: 500;
    color: #8f8d8d;
    letter-spacing: 1.5px;
  }
`;

export const TempDetails = styled.div`
  font-size: 11px;
  color: #b1b1b1;
  letter-spacing: 1px;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-transform: uppercase;
  margin: 4%;
  margin-left: 10%;
  margin-right: 10%;
  margin-bottom: ${props => !props.accessMailRoomData && '0'};
  width: 87%;
  p {
    font-size: 12px;
    text-transform: uppercase;
    color: #000;
    letter-spacing: 1px;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .tempDetail {
    display: flex;
    flex-direction: column;
    height: 130px;
    justify-content: space-between;
  }
  .variables {
    display: flex;
    flex-direction: row;
    margin-top: 5px;
    p {
      border: 2px solid #c3c3c3;
      margin-right: 15px;
      font-size: 10px !important;
      background: #c3c3c3;
      color: #fff;
    }
    .varDetails {
      border: none !important;
      background: none !important;
      color: #000 !important;
      text-transform: none;
      font-size: 12px !important;
      font-weight: 400;
      cursor: pointer;
      text-decoration: underline;
    }
    .noVar {
      text-decoration: none;
      cursor: initial;
    }
  }
`;
